import { render } from "./ProductBrandListComponent.vue?vue&type=template&id=65b979fe"
import script from "./ProductBrandListComponent.vue?vue&type=script&lang=js"
export * from "./ProductBrandListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/ProductBrand/ProductBrandListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65b979fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65b979fe', __exports__)) {
    api.reload('65b979fe', __exports__)
  }
  
  module.hot.accept("./ProductBrandListComponent.vue?vue&type=template&id=65b979fe", () => {
    api.rerender('65b979fe', render)
  })

}


export default __exports__